export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11340.e04f6015.jpg";